import { render, staticRenderFns } from "./DIASRealEstateAccordion.vue?vue&type=template&id=af671f4e&"
import script from "./DIASRealEstateAccordion.vue?vue&type=script&lang=js&"
export * from "./DIASRealEstateAccordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports